export const GET_REQUEST = 'LOCK_UNLOCK_VIDEO/REQUEST';
export const GET_SUCCESS = 'LOCK_UNLOCK_VIDEO/SUCCESS';
export const GET_FAIL = 'LOCK_UNLOCK_VIDEO/FAIL';
